import { render } from "./DetailOld.vue?vue&type=template&id=c7753a60&scoped=true&bindings={}"
import script from "./DetailOld.vue?vue&type=script&lang=ts"
export * from "./DetailOld.vue?vue&type=script&lang=ts"

import "./DetailOld.vue?vue&type=style&index=0&id=c7753a60&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c7753a60"

export default script